export enum RequestStateEnum {
  FAILED = "failed",
  LOADING = "loading",
  FULLFILLED = "fullfilled",
  NODATA = "nodata",
}

export type Nullable<T> = T | null;
